export default __webpack_public_path__ + "static/media/animatedDot.9c8186b3.gif";